const prcct = typeof $ === "function" ? $("body").data("cmpprice") : undefined;
const fsProductDataMap = new WeakMap();

function normalizePathname(pathname) {
  return String(pathname || "").replace(/^\/[a-z]{2}(?:-[a-z]{2})?\//i, "/");
}

function isCollectionPage() {
  if (document.body && document.body.classList.contains("template-collection")) return true;
  const p = normalizePathname(location.pathname);
  return /^\/collections\/[^/]+/i.test(p);
}

function isSearchPage() {
  if (document.body && document.body.classList.contains("template-search")) return true;
  const p = normalizePathname(location.pathname);
  if (/^\/search(?:\/|$)/i.test(p)) return true;
  if (/^\/pages\/search(?:\/|$)/i.test(p)) return true;
  return false;
}

function initFsHomePageCardObserver() {
  if (window.__sgFsHomePageCardObserver) return;
  window.__sgFsHomePageCardObserver = true;

  const HOME_CARD_SELECTOR = [
    ".autocomplete-inner a.fs-product.item",
    ".fast-horizontal-products a.fs-product.item",
    ".autocomplete-inner .fs-product.item",
    ".fast-horizontal-products .fs-product.item"
  ].join(",");

  const enhanceCard = (card) => {
    if (!card || !(card instanceof HTMLElement)) return;

    const domData = sgExtractDataFromDomCard(card);
    sgApplyCardEnhancements(card, domData);

    const handle = sgExtractHandleFromCard(card);
    if (!handle) return;

    const prevHandle = card.dataset.sgHandleFetched;
    if (prevHandle === handle) return;
    card.dataset.sgHandleFetched = handle;

    sgFetchHomeCardDataByHandle(handle).then((shopifyData) => {
      const merged = {
        ...(domData || {}),
        ...(shopifyData || {}),
        tags:
          (domData?.tags && domData.tags.length ? domData.tags : shopifyData?.tags) || [],
        attributes:
          (domData?.attributes && domData.attributes.length ? domData.attributes : shopifyData?.attributes) || [],
        promotion:
          domData?.promotion || shopifyData?.promotion || ""
      };
      sgApplyCardEnhancements(card, merged);
    });
  };

  const applyAll = (root) => {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll(HOME_CARD_SELECTOR).forEach((card) => {
      enhanceCard(card);
      setTimeout(() => enhanceCard(card), 180);
      setTimeout(() => enhanceCard(card), 450);
      setTimeout(() => enhanceCard(card), 800);
    });
  };

  applyAll(document);

  const mo = new MutationObserver((mutations) => {
    mutations.forEach((m) => {
      m.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;

        if (node.matches?.(HOME_CARD_SELECTOR)) {
          enhanceCard(node);
          setTimeout(() => enhanceCard(node), 180);
          setTimeout(() => enhanceCard(node), 450);
          setTimeout(() => enhanceCard(node), 800);
        }

        if (node.querySelectorAll) {
          applyAll(node);
        }
      });
    });
  });

  mo.observe(document.body, {
    childList: true,
    subtree: true
  });
}

function hooks() {
  function traverseShadowRoots(rootNode, selector) {
    const seen = new Set();
    const queue = [rootNode];

    while (queue.length) {
      const node = queue.shift();
      if (!node || seen.has(node)) continue;
      seen.add(node);

      try {
        if (node.querySelector) {
          const found = node.querySelector(selector);
          if (found) return found;
        }
      } catch (_) {}

      const sr = node.shadowRoot;
      if (sr) queue.push(sr);

      const children = node.childNodes;
      if (children && children.length) {
        for (let i = 0; i < children.length; i++) queue.push(children[i]);
      }
    }
    return null;
  }

  function applyFsPageTypeClasses(targetEl) {
    const isCol = isCollectionPage();
    const isSea = isSearchPage();
    const page = isCol ? "collection" : isSea ? "search" : "other";

    document.documentElement.classList.toggle("sg-fs-collection", isCol);
    document.documentElement.classList.toggle("sg-fs-search", isSea);
    document.body.classList.toggle("sg-fs-collection", isCol);
    document.body.classList.toggle("sg-fs-search", isSea);

    const root = document.querySelector("#fast-simon-serp-app");
    if (root) {
      root.classList.toggle("sg-fs-collection", isCol);
      root.classList.toggle("sg-fs-search", isSea);
      root.setAttribute("data-sg-page", page);
    }

    if (targetEl && targetEl.classList) {
      targetEl.classList.toggle("sg-fs-collection", isCol);
      targetEl.classList.toggle("sg-fs-search", isSea);
      targetEl.setAttribute("data-sg-page", page);
    }

    let grid = null;
    const sr = root && root.shadowRoot ? root.shadowRoot : null;
    if (sr) grid = sr.querySelector(".filters-grid-wrapper");
    if (!grid) grid = traverseShadowRoots(document, ".filters-grid-wrapper");

    if (grid && grid.classList) {
      grid.classList.toggle("sg-fs-collection", isCol);
      grid.classList.toggle("sg-fs-search", isSea);
      grid.setAttribute("data-sg-page", page);
    }

    return !!grid;
  }

  applyFsPageTypeClasses(document.body);

  (function installFsPageTypeMaintainer() {
    if (window.__sgFsPageTypeMaintainer) return;
    window.__sgFsPageTypeMaintainer = true;

    let tries = 0;
    const iv = setInterval(() => {
      tries++;
      const ok = applyFsPageTypeClasses(document.body);
      if (ok || tries > 40) clearInterval(iv);
    }, 500);

    const mo = new MutationObserver(() => applyFsPageTypeClasses(document.body));
    mo.observe(document.documentElement, { childList: true, subtree: true });

    window.addEventListener("popstate", () => applyFsPageTypeClasses(document.body));
  })();

  window.SerpOptions.registerHook("serp-top-page", ({ element }) => {
    if (!element) return;
    applyFsPageTypeClasses(element);

    const titleEl = element.querySelector(".fs-page-title");
    if (!titleEl) return;

    if (isCollectionPage()) {
      titleEl.classList.add("sg-fs-title-collection");
      titleEl.classList.remove("sg-fs-title-search");
    } else if (isSearchPage()) {
      titleEl.classList.add("sg-fs-title-search");
      titleEl.classList.remove("sg-fs-title-collection");
    } else {
      titleEl.classList.remove("sg-fs-title-search");
      titleEl.classList.remove("sg-fs-title-collection");
    }
  });

  window.SerpOptions.registerHook("serp-filters", ({ element }) => {
    if (!element) return;
    applyFsPageTypeClasses(element);

    element.querySelectorAll(".color-swatch-color-name").forEach((s) => {
      if (s.innerHTML === "White") s.classList.add("white");
    });

    const pageParent = element.closest("#fs-serp-page");
    if (pageParent && pageParent.querySelector(".filters-container") && window.innerWidth > 480) {
      addFilterButtons(pageParent);
      updateFilterButtons(pageParent);
    }
  });

  window.SerpOptions.registerHook("serp-product-grid", ({ products, element }) => {
    applyFsPageTypeClasses(element);

    getProductElements(element).forEach((productElement) => {
      const productID = productElement.dataset.productId;
      const data = products[productID];

      fsProductDataMap.set(productElement, data);

      productElement.querySelector(".my-promo-tags")?.remove();

      sgRenderUnifiedBadges(productElement, data);
      sgUpdatePriceRange(productElement, data);
      addprm(productElement, data);
      formatEuroPrice(productElement, data);
      runRemoveFromText(productElement);

      const imageCon = productElement.querySelector(".image-container");
      if (imageCon && !imageCon.classList.contains("first-img-quality-fix") && window.innerWidth < 480) {
        imageCon.classList.add("first-img-quality-fix");
        const img = imageCon.querySelector(".image");
        if (img) {
          const src = img.getAttribute("src") || "";
          if (src.includes("_657x.")) img.setAttribute("src", src.replace("_657x.", "."));
          else if (src.includes("_486x.")) img.setAttribute("src", src.replace("_486x.", "."));
          img.style.aspectRatio = "auto";
          img.style.imageRendering = "auto";
        }
      }

      moveBadge(productElement);

      const vendorEl = productElement.querySelector(".vendor-container");
      if (vendorEl) {
        const isBeautyRaw = GetattributevalueCI(data?.attributes, "My fields.isbeauty");
        const isBeauty = String(isBeautyRaw || "").trim().toLowerCase();

        const vendorName =
          GetattributevalueCI(data?.attributes, "vendor") ||
          GetattributevalueCI(data?.attributes, "brand") ||
          vendorEl.textContent ||
          "";

        const vendorHandle = String(vendorName)
          .trim()
          .toLowerCase()
          .replace(/['"]/g, "")
          .replace(/&/g, " and ")
          .replace(/[^a-z0-9]+/g, "-")
          .replace(/^-+|-+$/g, "");

        const rootUrl = window.Shopify?.routes?.root || "/";
        const vendorUrl = `${rootUrl}collections/${vendorHandle}`;

        if (isBeauty === "false" || isBeauty === "0" || isBeauty === "no") {
          vendorEl.style.setProperty("display", "none");
        } else {
          vendorEl.style.removeProperty("display");
          if (vendorHandle) {
            renderVendorLink(vendorEl, vendorName, vendorUrl);
          }
        }
      }

      replaceSwatchesWithCount(productElement);
    });

    setTimeout(copyhtmlTitle, 400);
    setTimeout(nofilterCheck, 400);
  });

  function hideFsSummarySearchTermOnCollection() {
    if (!isCollectionPage()) return;

    const SELECTOR = ".searchTerm.fs-summary-search-term";

    const apply = () => {
      const el = traverseShadowRoots(document, SELECTOR);
      if (!el) return false;
      if (el.dataset.sgHidden === "1") return true;
      el.style.display = "none";
      el.dataset.sgHidden = "1";
      return true;
    };

    apply();

    const mo = new MutationObserver(() => apply());
    mo.observe(document.documentElement, { childList: true, subtree: true });

    const iv = setInterval(() => {
      if (apply()) clearInterval(iv);
    }, 300);
  }

  function pinTopCenterContainerOnCollection() {
    if (!isCollectionPage()) return;

    const apply = () => {
      const root = document.querySelector("#fast-simon-serp-app");
      const sr = root && root.shadowRoot ? root.shadowRoot : null;
      if (!sr) return false;

      const el = sr.querySelector(".top-center-container");
      if (!el) return false;

      if (el.dataset.sgTopPinned === "1") return true;

      el.style.top = "0px";
      const pos = window.getComputedStyle(el).position;
      if (pos === "static") el.style.position = "relative";

      el.dataset.sgTopPinned = "1";
      return true;
    };

    apply();

    const mo = new MutationObserver(() => apply());
    mo.observe(document.documentElement, { childList: true, subtree: true });

    const iv = setInterval(() => {
      if (apply()) clearInterval(iv);
    }, 300);
  }

  function hooksFilter() {
    function updateZIndex(setTo) {
      const announcementSection = document.querySelector('#root > [class*="shopify-section-announcement"]');
      const headerSection = document.querySelector(".shopify-section-header");
      const bodyElement = document.querySelector("body");
      const htmlElement = document.querySelector("html");
      const z = setTo === -1 ? "-1" : "99";
      if (announcementSection) announcementSection.style.zIndex = z;
      if (headerSection) headerSection.style.zIndex = z;
      const ov = setTo === -1 ? "hidden" : "";
      bodyElement.style.overflowY = ov;
      htmlElement.style.overflowY = ov;
    }

    function handleBackgroundClick(filterModal) {
      filterModal.addEventListener("click", (e) => {
        const modalContent = filterModal.querySelector(".filters-modal");
        if (!modalContent || !modalContent.contains(e.target)) updateZIndex(99);
      });
    }

    function observeModalAddition() {
      const filterModal = traverseShadowRoots(document, ".filters-modal-wrapper.fs-result-page-j6l4zq");
      if (filterModal) {
        updateZIndex(-1);
        handleBackgroundClick(filterModal);
      } else {
        const observer = new MutationObserver((ml) => {
          ml.forEach((m) => {
            m.addedNodes.forEach(() => {
              const fm = traverseShadowRoots(document, ".filters-modal-wrapper.fs-result-page-j6l4zq");
              if (fm) {
                updateZIndex(-1);
                handleBackgroundClick(fm);
                observer.disconnect();
              }
            });
          });
        });
        observer.observe(document.body, { childList: true, subtree: true });
      }
    }

    function fastFilterButtonCheck() {
      const filterButton = traverseShadowRoots(document, ".filters-button-wrapper");
      if (filterButton) {
        filterButton.removeEventListener("click", handleFilterButtonClick);
        filterButton.addEventListener("click", handleFilterButtonClick);
      }
    }

    function handleFilterButtonClick() {
      observeModalAddition();
    }

    setInterval(fastFilterButtonCheck, 500);
    const observer = new MutationObserver((ml) => {
      ml.forEach((m) => {
        m.addedNodes.forEach(() => fastFilterButtonCheck());
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener("DOMContentLoaded", fastFilterButtonCheck);
  }

  hooksFilter();
  hideFsSummarySearchTermOnCollection();
  pinTopCenterContainerOnCollection();
}

function addFilterButtons(pageParent) {
  const filtersContainer = pageParent.querySelector(".filters-container");
  if (filtersContainer.querySelector(".filter-popup__bottom-buttons-fs")) return;

  const filterButtons = `<div class="filter-popup__bottom-buttons-fs">
      <a class="btn btn--outline pt-btn-disabled-fs">Clear</a>
      <button class="pt-apply btn">See Items</button>
    </div>`;
  filtersContainer.insertAdjacentHTML("beforeend", filterButtons);

  const clearButton = filtersContainer.querySelector("a.pt-btn-disabled-fs");
  const applyButton = filtersContainer.querySelector("button.pt-apply");

  clearButton?.addEventListener("click", () => {
    if (!clearButton.classList.contains("pt-btn-disabled-fs")) {
      document.dispatchEvent(new CustomEvent("send-fast-simon-params", { detail: { narrow: {} } }));
    }
  });

  applyButton?.addEventListener("click", () => {
    pageParent.querySelector(".filters-modal-wrapper")?.click();
  });

  setTimeout(() => updateFilterButtons(pageParent), 200);
}

function updateFilterButtons(pageParent) {
  const numOfFilters = pageParent.querySelectorAll(".removable-tags-wrapper .removable-tag").length;
  const clearButton = pageParent.querySelector(".filter-popup__bottom-buttons-fs a");
  const applyButton = pageParent.querySelector(".filter-popup__bottom-buttons-fs button");
  const resultsText = pageParent.querySelector(".fs-total-results-text")?.innerHTML.split(" ")[0];

  if (numOfFilters === 0) clearButton?.classList.add("pt-btn-disabled-fs");
  else clearButton?.classList.remove("pt-btn-disabled-fs");

  if (resultsText && applyButton) applyButton.innerHTML = `See ${resultsText} Results`;
}

function copyhtmlTitle() {
  const titleWrapper = document.querySelector(".collection-title__wrapper");
  const subcollections = document.querySelector(".collection-subcollections")?.outerHTML;
  const root = document.querySelector("#fast-simon-serp-app");
  const targetElement = root && root.shadowRoot ? root.shadowRoot.querySelector(".top-center-container") : null;

  if (titleWrapper && targetElement && !targetElement.querySelector(".acctitle")) {
    const htmlToPrepend = `<div class='acctitle'>${titleWrapper.innerHTML}</div>${subcollections || ""}`;
    targetElement.classList.add("sg-cltn");
    targetElement.insertAdjacentHTML("afterbegin", htmlToPrepend);
  }
}

function activateMatchingLinks() {
  const links = document.querySelectorAll(".collection-card__location");
  const currentUrlHandler = window.location.pathname.split("/").pop();
  links.forEach((link) => {
    const linkHrefHandler = link.getAttribute("href").split("/").pop();
    if (linkHrefHandler === currentUrlHandler) link.classList.add("active");
  });
}
document.addEventListener("DOMContentLoaded", activateMatchingLinks);

function nofilterCheck() {
  const root = document.querySelector("#fast-simon-serp-app");
  const filtersWrapper = root && root.shadowRoot ? root.shadowRoot.querySelector(".filters-grid-wrapper") : null;
  if (filtersWrapper?.classList.contains("filters-grid-no-filters")) {
    $(".blnkbx").remove();
    $(".collection-nav-grid, .collection-sub-grid").css("grid-template-columns", "unset");
  }
}

function openHeaderCartDrawerFallback() {
  const trigger =
    document.querySelector("[data-cart-link]") ||
    document.querySelector(".header__utils-link--cart") ||
    document.querySelector("[data-cart-toggle]");
  if (!trigger) return;
  trigger.dispatchEvent(new MouseEvent("click", { bubbles: true, cancelable: true, view: window }));
}

function findDefaultVariantIdFromFsData(data) {
  if (!data) return null;
  if (data.selectedVariantId) return data.selectedVariantId;
  if (data.defaultVariantId) return data.defaultVariantId;
  if (Array.isArray(data.variants) && data.variants.length) {
    const firstAvail =
      data.variants.find((v) => v.available === true || v.isAvailable === true || v.isInStock === true) ||
      data.variants[0];
    return firstAvail.id || firstAvail.variantId || firstAvail.shopifyVariantId || null;
  }
  return null;
}

function initFsAtcDrawerSync() {
  if (window.__fsAtcDrawerBound) return;
  window.__fsAtcDrawerBound = true;

  document.addEventListener(
    "click",
    function (e) {
      let btn = null;
      let path = e.composedPath ? e.composedPath() : null;

      if (path) {
        for (let i = 0; i < path.length; i++) {
          const node = path[i];
          if (node && node.nodeType === 1 && node.matches && node.matches(".fs-add-to-cart-button")) {
            btn = node;
            break;
          }
        }
      }

      if (!btn && e.target && e.target.closest) {
        btn = e.target.closest(".fs-add-to-cart-button");
      }

      if (!btn) return;

      let productElement = null;
      if (path) {
        for (let i = 0; i < path.length; i++) {
          const node = path[i];
          if (node && node.nodeType === 1 && node.classList && node.classList.contains("fs-results-product-card")) {
            productElement = node;
            break;
          }
        }
      }
      if (!productElement && btn.closest) {
        productElement = btn.closest(".fs-results-product-card");
      }

      const data = productElement ? fsProductDataMap.get(productElement) : null;
      const variants = Array.isArray(data?.variants) ? data.variants : [];

      if (!data || variants.length > 1) return;

      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();

      const variantIdRaw = findDefaultVariantIdFromFsData(data);
      if (!variantIdRaw) {
        const url = findProductUrlFromCard(productElement || document);
        if (url) window.location.href = url;
        return;
      }

      const match = String(variantIdRaw).match(/\d+$/);
      const variantId = match ? match[0] : variantIdRaw;

      const addUrl =
        typeof routes !== "undefined" && routes.cart_add_url ? `${routes.cart_add_url}.js` : "/cart/add.js";

      fetch(addUrl, {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      })
        .then((r) => r.json().catch(() => null))
        .then(() => {
          const sectionsUrl = `${window.location.pathname}?sections=cart-drawer,cart-counter`;
          return fetch(sectionsUrl, { credentials: "same-origin" });
        })
        .then((r) => r.text())
        .then((text) => {
          let json = null;
          try {
            json = JSON.parse(text);
          } catch (e) {
            openHeaderCartDrawerFallback();
            return;
          }

          const cartDrawer = document.querySelector("cart-drawer");
          if (cartDrawer && typeof cartDrawer.renderContents === "function") {
            try {
              cartDrawer.renderContents({ sections: json }, true);
            } catch (e) {
              openHeaderCartDrawerFallback();
            }
          } else {
            openHeaderCartDrawerFallback();
          }
        })
        .catch(() => openHeaderCartDrawerFallback());
    },
    true
  );
}

initFsAtcDrawerSync();

if (window.SerpOptions) {
  hooks();
} else {
  window.addEventListener("fast-serp-ready", hooks);
}

initFsHomePageCardObserver();
